var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.order)?_c('order-form',{attrs:{"init-order":_vm.order,"init-product":_vm.product,"val-errors":_vm.valErrors,"settings":_vm.settings,"submit-text":"Erstellen"},on:{"submit":_vm.submit}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }